"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var hooks_1 = require("@chakra-ui/hooks");
var react_1 = require("@chakra-ui/react");
var ModalInquire_1 = require("../inquire/ModalInquire");
var Footer_1 = require("./components/Footer");
var Header_1 = require("./components/Header");
var Layout = function (_a) {
    var headerUrl = _a.headerUrl, _b = _a.isHeader, isHeader = _b === void 0 ? true : _b, _c = _a.isFooter, isFooter = _c === void 0 ? true : _c, _d = _a.isInquire, isInquire = _d === void 0 ? false : _d, _e = _a.isLoading, isLoading = _e === void 0 ? false : _e, _f = _a.headerMenus, headerMenus = _f === void 0 ? null : _f, shopCode = _a.shopCode, children = _a.children;
    var _g = (0, hooks_1.useDisclosure)(), isOpen = _g.isOpen, onOpen = _g.onOpen, onClose = _g.onClose;
    return ((0, jsx_runtime_1.jsxs)(react_1.Box, __assign({ minHeight: "100vh", position: "relative", boxSizing: "border-box", paddingBottom: isFooter ? "4rem" : undefined }, { children: [isHeader && ((0, jsx_runtime_1.jsx)(Header_1.Header, { headerUrl: headerUrl, onOpen: onOpen, isInquire: isInquire, headerMenus: headerMenus, shopCode: shopCode }, void 0)), children, !isLoading && isFooter && (0, jsx_runtime_1.jsx)(Footer_1.Footer, {}, void 0), (0, jsx_runtime_1.jsx)(ModalInquire_1.ModalInquire, { isOpen: isOpen, onOpen: onOpen, onClose: onClose }, void 0)] }), void 0));
};
exports.Layout = Layout;
